"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activities.panel.all': 'All Activities',
    'activities.panel.telegram': 'Telegram',
    'activities.panel.whatsapp': 'WhatsApp',
    'activities.panel.noLogs': 'No activities to display.',
    'activities.panel.noData': 'No channel data available.',
    'activities.panel.groups': 'Groups',
    'activities.panel.channels': 'Channels/Groups',
    'activities.panel.inboxes': 'Inboxes',
    'activities.panel.trackingEnabled': 'Tracking enabled',
    'activities.panel.connectionActive': 'Connection active',
    'activities.panel.critical': 'Critical',
    'activities.panel.criticalDetected': 'Critical detected',
    'activities.panel.noAlerts': 'No alerts',
    'activities.panel.requiresAction': 'Requires action',
    'activities.panel.spamQueue': 'Spam/Queue',
    'activities.panel.warning': 'Warning',
    'activities.panel.noWarnings': 'No warnings',
    'activities.panel.status': 'Status',
    'activities.panel.status.good': 'Good',
    'activities.panel.status.warning': 'Warning',
    'activities.panel.status.danger': 'Danger',
    'activities.panel.lastSync': 'Last sync',
    'activities.panel.neverSynced': 'Never',
    'activities.panel.justNow': 'Just now',
    'activities.panel.minutesAgo': 'min ago',
    'activities.panel.hoursAgo': 'h ago',
    'activities.panel.daysAgo': 'd ago',
};
